module.exports = __webpack_public_path__ + "assets/img/sm2.03510a29.png";